const results = [
  'более самостоятельные сотрудники;',
  'более быстрая передача опыта;',
  'снижение зависимости от отдельных специалистов;',
  'повышение качества адаптации;',
  'развитие внутренних экспертов;',
  'подготовка кадрового резерва;',
  'более системное развитие сотрудников;',
  'снижение количества повторяющихся ошибок;',
  'развитие руководителей через наставничество;',
  'сохранение критически важных знаний внутри компании;',
  'повышение ответственности сотрудников;',
  'формирование культуры развития.',
];

export default function CompanyResults() {
  return (
    <section id="results" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Потенциальные результаты системного наставничества. Мы не обещаем конкретный финансовый результат — итог зависит от внедрения
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-3 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{r}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}